import React, { useState, useEffect } from "react";
import { 
  FaWhatsapp, 
  FaLinkedin, 
  FaTwitter, 
  FaInstagram, 
  FaFacebook, 
  FaYoutube, 
  FaTelegram,
  FaShareAlt,
  FaHeart,
  FaGlobe,
  FaEnvelope
} from "react-icons/fa";
import "../styles/SocialStrip.css";

const SocialStrip = () => {
  const [isHovered, setIsHovered] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const socialLinks = [
    { 
      name: "WhatsApp", 
      icon: <FaWhatsapp />, 
      url: "https://wa.me/9187428203483",
      color: "#25D366",
      bgColor: "rgba(37, 211, 102, 0.1)",
      followers: "10k+",
      handle: "@indiandetective"
    },
    { 
      name: "LinkedIn", 
      icon: <FaLinkedin />, 
      url: "https://linkedin.com/company/indian-detective",
      color: "#0077B5",
      bgColor: "rgba(0, 119, 181, 0.1)",
      followers: "25k+",
      handle: "@indian-detective"
    },
    { 
      name: "Twitter", 
      icon: <FaTwitter />, 
      url: "https://twitter.com/indian_detective",
      color: "#1DA1F2",
      bgColor: "rgba(29, 161, 242, 0.1)",
      followers: "15k+",
      handle: "@indian_detective"
    },
    { 
      name: "Instagram", 
      icon: <FaInstagram />, 
      url: "https://instagram.com/indian_detective",
      color: "#E4405F",
      bgColor: "rgba(228, 64, 95, 0.1)",
      followers: "30k+",
      handle: "@indian_detective"
    },
    { 
      name: "Facebook", 
      icon: <FaFacebook />, 
      url: "https://facebook.com/indiandetective",
      color: "#1877F2",
      bgColor: "rgba(24, 119, 242, 0.1)",
      followers: "20k+",
      handle: "/indiandetective"
    },
    { 
      name: "YouTube", 
      icon: <FaYoutube />, 
      url: "https://youtube.com/@indiandetective",
      color: "#FF0000",
      bgColor: "rgba(255, 0, 0, 0.1)",
      followers: "5k+",
      handle: "@indiandetective"
    }
  ];

  const formattedTime = currentTime.toLocaleTimeString('en-US', { 
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit'
  });

  return (
    <div className="social-strip-premium">
      <div className="social-premium-container">
        {/* Left Section - Brand & Time */}
        <div className="social-left">
          <div className="brand-tag">
            <FaHeart className="brand-heart" />
            <span>Connect With Us</span>
          </div>
          <div className="live-time">
            <div className="time-dot"></div>
            <span>{formattedTime} IST</span>
          </div>
        </div>

        {/* Center Section - Social Links */}
        <div className="social-center">
          <div className="social-links-premium">
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`social-link-premium ${isHovered === index ? "hovered" : ""}`}
                onMouseEnter={() => setIsHovered(index)}
                onMouseLeave={() => setIsHovered(null)}
                style={{ 
                  backgroundColor: isHovered === index ? link.color : link.bgColor,
                  borderColor: isHovered === index ? link.color : "rgba(255,255,255,0.1)"
                }}
              >
                <div className="link-icon" style={{ color: isHovered === index ? "white" : link.color }}>
                  {link.icon}
                </div>
                <div className="link-tooltip">
                  <span className="tooltip-name">{link.name}</span>
                  <span className="tooltip-followers">{link.followers} followers</span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Right Section - Newsletter & Share */}
        <div className="social-right">
          <div className="newsletter-badge">
            <FaEnvelope className="newsletter-icon" />
            <span>Newsletter</span>
          </div>
          <button className="share-button">
            <FaShareAlt />
            <span>Share</span>
          </button>
        </div>
      </div>

      {/* Floating Social Bar (Desktop) */}
      <div className="floating-social-bar">
        <div className="floating-label">
          <FaGlobe />
          <span>Follow Us</span>
        </div>
        <div className="floating-icons">
          {socialLinks.slice(0, 4).map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="floating-icon"
              style={{ backgroundColor: link.color }}
            >
              {link.icon}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SocialStrip;

const MobileSocialBar = () => (
  <div className="mobile-social-bar">
    <a href="https://wa.me/9187428203483" className="mobile-social-link" style={{ color: "#25D366" }}>
      <FaWhatsapp />
      <span>WhatsApp</span>
    </a>
    <a href="#" className="mobile-social-link" style={{ color: "#0077B5" }}>
      <FaLinkedin />
      <span>LinkedIn</span>
    </a>
    <a href="#" className="mobile-social-link" style={{ color: "#1DA1F2" }}>
      <FaTwitter />
      <span>Twitter</span>
    </a>
    <a href="#" className="mobile-social-link" style={{ color: "#E4405F" }}>
      <FaInstagram />
      <span>Instagram</span>
    </a>
  </div>
);
